import { gql } from '@apollo/client';

/**
 * 「换单打印日志查询」外部员工版本（HUB_OPERATOR / SORTING_STAFF 等一线角色调用）。
 * 与 GET_ORDER_REPRINT_LOGS 字段结构一致；用 GraphQL 别名保持响应字段名 `getOrderReprintLogs` 不变，
 * 下游可直接复用 OrderReprintLogsResponse 类型。
 */
export const GET_ORDER_REPRINT_LOGS_FOR_EXTERNAL_STAFF = gql`
    query GetOrderReprintLogsForExternalStaff(
        $hubId: Long
        $warehouseId: Long
        $startTime: Long
        $endTime: Long
        $accountId: Long
        $source: Int
        $page: Int!
        $size: Int!
    ) {
        getOrderReprintLogs: getOrderReprintLogsForExternalStaff(
            hubId: $hubId
            warehouseId: $warehouseId
            startTime: $startTime
            endTime: $endTime
            accountId: $accountId
            source: $source
            page: $page
            size: $size
        ) {
            content {
                id
                source
                neutralTrackingNumber
                reprintTrackingNumber
                trackingNumber
                status
                failureType
                failureReason
                processingTimeMs
                createdAt
            }
            totalElements
            page
            totalPages
        }
    }
`;
